"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceToJSON = exports.InvoiceFromJSONTyped = exports.InvoiceFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function InvoiceFromJSON(json) {
    return InvoiceFromJSONTyped(json, false);
}
exports.InvoiceFromJSON = InvoiceFromJSON;
function InvoiceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'invoiceId': json['invoiceId'],
        'invoiceNumber': json['invoiceNumber'],
        'invoiceDate': json['invoiceDate'],
        'customerNumber': json['customerNumber'],
        'invoiceAddress': (0, _1.AddressFromJSON)(json['invoiceAddress']),
        'deliveryAddress': (0, _1.AddressFromJSON)(json['deliveryAddress']),
        'paymentMethod': json['paymentMethod'],
        'products': (json['products'].map(_1.ProductFromJSON)),
        'subTotal': (0, _1.AmountFromJSON)(json['subTotal']),
        'priceModifications': !(0, runtime_1.exists)(json, 'priceModifications') ? undefined : (json['priceModifications'].map(_1.PriceModificationFromJSON)),
        'grandTotal': (0, _1.AmountFromJSON)(json['grandTotal']),
        'paymentPlan': !(0, runtime_1.exists)(json, 'paymentPlan') ? undefined : (json['paymentPlan'].map(_1.InvoicePaymentPlanFromJSON)),
        'paymentHint': !(0, runtime_1.exists)(json, 'paymentHint') ? undefined : json['paymentHint'],
        'showEffectiveInstallmentsHint': !(0, runtime_1.exists)(json, 'showEffectiveInstallmentsHint') ? undefined : json['showEffectiveInstallmentsHint'],
    };
}
exports.InvoiceFromJSONTyped = InvoiceFromJSONTyped;
function InvoiceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'invoiceId': value.invoiceId,
        'invoiceNumber': value.invoiceNumber,
        'invoiceDate': value.invoiceDate,
        'customerNumber': value.customerNumber,
        'invoiceAddress': (0, _1.AddressToJSON)(value.invoiceAddress),
        'deliveryAddress': (0, _1.AddressToJSON)(value.deliveryAddress),
        'paymentMethod': value.paymentMethod,
        'products': (value.products.map(_1.ProductToJSON)),
        'subTotal': (0, _1.AmountToJSON)(value.subTotal),
        'priceModifications': value.priceModifications === undefined ? undefined : (value.priceModifications.map(_1.PriceModificationToJSON)),
        'grandTotal': (0, _1.AmountToJSON)(value.grandTotal),
        'paymentPlan': value.paymentPlan === undefined ? undefined : (value.paymentPlan.map(_1.InvoicePaymentPlanToJSON)),
        'paymentHint': value.paymentHint,
        'showEffectiveInstallmentsHint': value.showEffectiveInstallmentsHint,
    };
}
exports.InvoiceToJSON = InvoiceToJSON;
//# sourceMappingURL=Invoice.js.map